import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Thanks.css';

const Thanks = () => {
    const location = useLocation();
    const navigate = useNavigate();

    // Contact.js から navigate('/thanks', { state: {...} }) で渡されたデータ
    const state      = location.state || {};
    const planLabel  = state.plan === 'free'
        ? '0円お試しプラン'
        : state.plan === 'standard'
            ? '通常プラン（¥55,000〜/月）'
            : null;
    const userName   = state.name  || '';

    return (
        <div className="thanks-page">
            {/* 背景装飾 */}
            <div className="thanks-bg-circle thanks-bg-circle--1"></div>
            <div className="thanks-bg-circle thanks-bg-circle--2"></div>

            <div className="thanks-card">
                {/* 成功アイコン */}
                <div className="thanks-icon-wrap">
                    <svg
                        className="thanks-checkmark"
                        viewBox="0 0 52 52"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                    >
                        <circle className="thanks-checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                        <path   className="thanks-checkmark__check"  fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                    </svg>
                </div>

                {/* タイトル */}
                <p className="thanks-eyebrow">THANK YOU</p>
                <h1 className="thanks-title">
                    お問い合わせ<wbr />ありがとうございます
                </h1>

                {/* 送信者名 */}
                {userName && (
                    <p className="thanks-username">
                        <span>{userName}</span> 様
                    </p>
                )}

                {/* 選択プラン */}
                {planLabel && (
                    <div className="thanks-plan-badge">
                        <span className="thanks-plan-label">ご選択プラン</span>
                        <span className="thanks-plan-value">{planLabel}</span>
                    </div>
                )}

                {/* メッセージ */}
                <div className="thanks-message">
                    <p>
                        内容を確認のうえ、担当者より<br className="sp-br" />
                        <strong>1〜2営業日以内</strong>にご連絡いたします。
                    </p>
                    <p className="thanks-message--sub">
                        ※ 返信が届かない場合はメールの迷惑フォルダをご確認いただくか、
                        直接お電話（090-2377-3553）にてお問い合わせください。
                    </p>
                </div>

                {/* 連絡先 */}
                <div className="thanks-contacts">
                    <div className="thanks-contact-item">
                        <span className="thanks-contact-icon">📞</span>
                        <div>
                            <div className="thanks-contact-label">お急ぎの場合</div>
                            <a href="tel:09023773553" className="thanks-contact-value">090-2377-3553</a>
                            <div className="thanks-contact-note">平日 9:00-18:00</div>
                        </div>
                    </div>
                    <div className="thanks-contact-item">
                        <span className="thanks-contact-icon">✉️</span>
                        <div>
                            <div className="thanks-contact-label">メール</div>
                            <a href="mailto:moribekazutaka@gmail.com" className="thanks-contact-value">
                                moribekazutaka@gmail.com
                            </a>
                            <div className="thanks-contact-note">24時間受付</div>
                        </div>
                    </div>
                </div>

                {/* 戻るボタン */}
                <button
                    className="thanks-back-btn"
                    onClick={() => navigate('/')}
                    type="button"
                >
                    ← トップページに戻る
                </button>
            </div>
        </div>
    );
};

export default Thanks;